<template>
  <div class="assign-telephone-task flex flex-col">
    <!-- 提示信息 提示已选中那些人 -->
    <!-- <div class="top-tips">
      <i class="el-icon-warning mx-2"></i>
      <span>已选中 {{ peopleName.slice(0, 3).join('、') }} 等共{{ peopleName.length }}人</span>
    </div> -->
    <div class="content flex items-center justify-around">
      <!-- 左边电话号富文本 -->
      <div class="phone-list">
        <div>添加样本手机号</div>
        <div class="text-red my-2">系统会将以下号码平均分配给选中的调查员</div>
        <div>
          <el-input type="textarea" :rows="15" :placeholder="placeholder" v-model="textareaContent"></el-input>
        </div>
      </div>
      <div class="form-content">
        <el-form ref="taskRuleForm" :label-position="labelPosition" label-width="140px" :model="formLabelAlign" :rules="rules">
          <!-- <el-form-item prop="price">
            <label slot="label"
              >答卷单价(元)
              <el-tooltip content="“答卷单价”为回收答卷质控通过后调查员的到手金额" placement="top">
                <span class="el-icon-question"></span> </el-tooltip
              >：
            </label>
            <el-input-number
              size="small"
              placeholder="支持两位小数、支持0和正数"
              v-model="formLabelAlign.price"
              :min="1"
              :precision="2"
              :controls="true"
              :step="0.01"
            ></el-input-number>
          </el-form-item>
          <el-form-item prop="count" label="样本数量：">
            {{ newCount }}
          </el-form-item> -->
          <el-form-item label="调查员：">
            <span>{{peopleName.length>1 ? `已选中${peopleName.length}人` : `${peopleName[0]}`}}</span>
          </el-form-item>
           <el-form-item :style="{ marginBottom: '0' }" label="结算类型：" prop="settleMethod">
            <div class="flex">
              <div class="inline-block">
                <div class="btn-box btn1 box-border" :class="{ 'btn-checked': btnChecked == 'online' }" @click="changeSettleMethod('online')">
                  <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'online')" :value="true"></el-checkbox>
                  <div>
                    <div class="text-theme-black-650 text-medium mb-2 font-semibold">线上结算
                      <div class="tujian bg-yellow-theme text-white inline-block text-center font-semibold text-small">
                        推荐
                      </div>
                    </div>
                    <div class="text-theme-black-450 text-small">线上支付调查员费用，调研工厂代调查员纳税，并为您的总花费开具发票</div>
                    <div class="flex justify-between mt-1" v-if="!isOpen">
                      <span class="text-yellow-theme text-small">
                        <i class="iconfont icon-jingshishuoming text-small font-semibold"></i>
                        尚未开通，无法使用
                      </span>
                      <span class="cursor-pointer text-theme text-small" @click="toOpen">去开通></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="inline-block">
                <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'offline' }" @click="changeSettleMethod('offline')">
                  <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'offline')" :value="true"></el-checkbox>
                  <div>
                    <div class="text-theme-black-650 text-medium mb-2 font-semibold">线下结算</div>
                    <div class="text-theme-black-450 text-small">常用场景：线下与调查员签署劳务协议、协商支付方式、纳税事宜等</div>
                  </div>
                </div>
              </div>
              <div class="inline-block">
                <div class="btn-box btn2 box-border" :class="{ 'btn-checked': btnChecked == 'neednot' }" @click="changeSettleMethod('neednot')">
                  <el-checkbox class="position-checkbox" :disabled = "!(btnChecked == 'neednot')" :value="true"></el-checkbox>
                  <div>
                    <div class="text-theme-black-650 text-medium mb-2 font-semibold">无需结算</div>
                    <div class="text-theme-black-450 text-small">常用场景：已同调查员签署劳动合同或调查员愿提供无偿服务等</div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            :style="{ marginBottom: formLabelAlign.settleMode ? '0' : '18px' }"
            label="结算方式："
            prop="settleMode"
            :rules="[{ required: !((!isOpen&&formLabelAlign.settleMethod==0)), message: ' ', trigger: 'change' }]"
          >
            <el-radio-group v-model="formLabelAlign.settleMode" @change="changeSettlementType" :disabled="(!isOpen&&formLabelAlign.settleMethod==0)">
              <el-radio :label="1">按答卷数量</el-radio>
              <el-radio :label="2">按天</el-radio>
              <el-radio v-if="!(btnChecked == 'neednot')" :label="3">按阶梯计价</el-radio>
            </el-radio-group>
          </el-form-item>

          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 1">
            <div class="flex-box" v-if="formLabelAlign.settleMethod!=2">
              <el-form-item
                label="单价（元）:"
                prop="settleRule.unitPriceYuan"
                :rules="[{ required: !((!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model="formLabelAlign.settleRule.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                  :disabled="(!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2"
                >
                </el-input-number>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="settlement-tips" v-if="formLabelAlign.settleMethod!=2">
              若用线上结算，请填写调查员到手金额，到手金额
              <el-button type="text" @click="$emit('emitChange', true)">计算器</el-button>
            </div>
            <div class="flex-box">
              <span class="pos-abs-box">
                <i>*</i>
                答卷数量:
                <el-tooltip
                  effect="dark"
                  content="该数量仅为参考回收数量，调查员可超额上报答卷，您可与调查员线下协商上报数量，采用线上结算时，可按照实际上报答卷数量进行结算"
                  placement="top"
                >
                  <div class="icon-wrap" style="margin-left: 4px">
                    <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </span>
              <el-form-item
                label=""
                prop="settleRule.expectedQuantity"
                :rules="[{ required: !((!isOpen&&formLabelAlign.settleMethod==0)), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                  :disabled="(!isOpen&&formLabelAlign.settleMethod==0)"
                >
                </el-input-number>
              </el-form-item>
              <span>份</span>
            </div>
            <div class="settlement-tips" style="margin-bottom: 0" v-if="formLabelAlign.settleMethod!=2">
              预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元
            </div>
          </div>
          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 2">
            <div class="flex-box" v-if="formLabelAlign.settleMethod!=2">
              <el-form-item
                label="单价（元）:"
                prop="settleRule.unitPriceYuan"
                :rules="[{ required: !((!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.unitPriceYuan"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="2"
                  :disabled="(!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2"
                >
                </el-input-number>
              </el-form-item>
              <span>元</span>
            </div>
            <div class="settlement-tips" v-if="formLabelAlign.settleMethod!=2">
              若用线上结算，请填写调查员到手金额，到手金额
              <el-button type="text" @click="$emit('emitChange', true)">计算器</el-button>
            </div>
            <div class="flex-box">
              <span class="pos-abs-box">
                <i>*</i>
                天数:
                <el-tooltip
                  effect="dark"
                  content="当天只要上报答卷即记为工作 1 天，该天数仅为参考工作天数，您可与调查员线下协商工作天数，采用线上结算时，可按照实际工作天数进行结算"
                  placement="top"
                >
                  <div class="icon-wrap" style="margin-left: 4px">
                    <span class="icon-font ico-tips" style="font-size: 12px">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </span>
              <el-form-item
                label=""
                prop="settleRule.expectedQuantity"
                :rules="[{ required: !((!isOpen&&formLabelAlign.settleMethod==0)), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                  :disabled="(!isOpen&&formLabelAlign.settleMethod==0)"
                >
                </el-input-number>
              </el-form-item>
              <span>天</span>
            </div>
            <div class="settlement-tips" style="margin-bottom: 0" v-if="formLabelAlign.settleMethod!=2">
              <div style="display: flex">
                <div>预估费用：{{ totalPriceYuan }}元，若采用线上结算，项目预计花费 {{ totalSaleYuan }}元</div>
                <el-tooltip
                  effect="dark"
                  :content="`项目预计费用=预估费用*（1+${accRate}），其中${accountingRateVal}为用于调查员待缴税及平台技术服务费`"
                  placement="top"
                >
                  <div class="icon-wrap">
                    <span class="icon-font ico-tips">&#xe65b;</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <div class="settlementType-style" style="margin: 16px 0" v-if="formLabelAlign.settleMode === 3">
            <el-form-item class="is-require-task" style="margin-bottom: 0" label="单价（元）:" v-if="formLabelAlign.settleMethod!=2">
              <div
                class="flex-settlement"
                v-for="(item, index) in formLabelAlign.settleRule.tiers"
                :key="index"
                :style="{ marginBottom: index === formLabelAlign.settleRule.tiers.length - 1 ? '0px' : '5px' }"
              >
                <span style="margin-right: 8px" v-show="index === 0">每天</span>
                <el-form-item label>
                  <el-input-number
                    v-if="index === 0"
                    :disabled="true"
                    placeholder=""
                    v-model="item.quantityLowerBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="0"
                    :max="Infinity"
                    :precision="0"
                  >
                  </el-input-number>
                  <el-input-number
                    v-if="index > 0"
                    :disabled="true"
                    placeholder=""
                    :value="formLabelAlign.settleRule.tiers[index - 1].quantityUpperBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="0"
                    :max="Infinity"
                    :precision="0"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin: 0 8px">份 &lt; 完成量 ≤</span>
                <el-form-item
                  label
                  :prop="'settleRule.tiers[' + index + '].quantityUpperBound'"
                  :rules="[{ required: !((!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2), message: ' ', trigger: 'blur' }]"
                >
                  <el-input-number
                    placeholder=""
                    v-model="item.quantityUpperBound"
                    autocomplete="off"
                    controls-position="right"
                    :min="index > 0 ? formLabelAlign.settleRule.tiers[index - 1].quantityUpperBound * 1 + 1 : 1"
                    :max="Infinity"
                    @change="val => currentInputNumber(val, item, index)"
                    :precision="0"
                    :disabled="(!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin: 0 8px">份，按完成量</span>
                <el-form-item
                  label
                  :prop="'settleRule.tiers[' + index + '].unitPriceYuan'"
                  :rules="[
                    {
                      required: !((!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2),
                      message: ' ',
                      trigger: 'blur'
                    }
                  ]"
                  style="margin-left: 10px"
                >
                  <el-input-number
                    placeholder=""
                    v-model.number="item.unitPriceYuan"
                    autocomplete="off"
                    controls-position="right"
                    :min="1"
                    :max="Infinity"
                    :precision="2"
                    :disabled="(!isOpen&&formLabelAlign.settleMethod==0)||formLabelAlign.settleMethod==2"
                  >
                  </el-input-number>
                </el-form-item>
                <span style="margin-left: 8px">元/份</span>
                <el-button v-if="index === 0" @click="handleSettlement('add', index)" class="btn-style" type="text"
                  ><i class="icon-font">&#xe68c;</i></el-button
                >
                <el-button
                  v-else-if="index === formLabelAlign.settleRule.tiers.length - 1"
                  @click="handleSettlement('remove', index)"
                  class="btn-style"
                  type="text"
                  ><i class="icon-font">&#xe68a;</i></el-button
                >
                <!-- <el-button @click="handleSettlement(index=== formLabelAlign.ladderSettlement.length-1 ? 'add' : 'remove')" class="btn-style" type="text"> {{index=== 0? '+':'-'}}</el-button> -->
              </div>
              <div class="settlement-tips left-0">
                若用线上结算，请填写调查员到手金额，到手金额
                <el-button type="text" @click="$emit('emitChange', true)">计算器</el-button>
              </div>
            </el-form-item>
            <div class="flex-box">
              <el-form-item
                style="margin-bottom: 0"
                label="天数:"
                prop="settleRule.expectedQuantity"
                :rules="[{ required: !((!isOpen&&formLabelAlign.settleMethod==0)), message: ' ', trigger: 'blur' }]"
              >
                <el-input-number
                  placeholder=""
                  v-model.number="formLabelAlign.settleRule.expectedQuantity"
                  autocomplete="off"
                  controls-position="right"
                  :min="1"
                  :max="Infinity"
                  :precision="0"
                  :disabled="(!isOpen&&formLabelAlign.settleMethod==0)"
                >
                </el-input-number>
              </el-form-item>
              <span>天</span>
            </div>
          </div>
          <div class="flex">
            <el-form-item style="flex:1" label="任务名称：" prop="taskName">
              <el-input v-model="formLabelAlign.taskName" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <el-form-item style="flex:1" label="截止时间：" prop="endTime">
              <el-date-picker
                type="datetime"
                placeholder="选择时间"
                v-model="formLabelAlign.endTime"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
              ></el-date-picker>
            </el-form-item>
          </div>
          <!-- <el-form-item label="预估费用：">
            <span>{{ aboutPrice }}元</span>
            <p class="inline-block ml-4" v-if="Number(GlobalConfig.getCompanyId())">
              推荐您通过调研工厂与调查员进行结算，为您节约成本
              <a class="text-blue cursor-pointer" @click="getMore">了解更多</a>
            </p>
          </el-form-item> -->
          <el-form-item label="描述：">
            <el-input placeholder="请输入内容" v-model="formLabelAlign.detail"></el-input>
          </el-form-item>
          <!-- <el-col :span="24"> -->
          <el-form-item label="执行要求：" prop="executionRequirement">
            <el-input placeholder="请输入执行要求" v-model="formLabelAlign.executionRequirement" autocomplete="off"></el-input>
          </el-form-item>
        <!-- </el-col> -->
        <!-- <el-col :span="24"> -->
          <el-form-item label="质控标准：" prop="qualityControlStandard">
            <el-input placeholder="请输入质控标准" v-model="formLabelAlign.qualityControlStandard" autocomplete="off"></el-input>
          </el-form-item>
        <!-- </el-col> -->
        </el-form>
      </div>
    </div>

    <div class="self-end">
      <div>
        <div class="settlement-tips" style="margin-bottom: 0" v-if="formLabelAlign.settleMethod!=2">
          {{formLabelAlign.settleMethod === 0 ? '线上' : '线下'}}结算预估花费:<span>{{ totalPriceYuan }}</span>元
        </div>
      </div>
      <div>
        <el-button @click="back">取消</el-button>
        <el-button type="primary" @click="distributeTask">确认</el-button>
      </div>
    </div>
    <OnlinePayService ref="onlinePayServiceVisible" />
  </div>
</template>

<script>
import { creatPhoneTask, checkPhoneList } from '@/api/wenjuan/telephone.js'
import { isLandline, isMobile } from '@/assets/js/validate.js'
import * as XlsxUtil from '@/assets/js/XlsxUtil'
import OnlinePayService from '@/components/online-pay-service'
import GlobalConfig from '@/global/config'

export default {
  name: 'assignTask',
  components: { OnlinePayService },
  props: {
    data: {
      type: Map
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      settleMethodMap: {
        'online':0,
        'offline':1,
        'neednot':2
      },
      btnCheckedMap: {
        0:'online',
        1:'offline',
        2:'neednot'
      },
      btnChecked: 'online',
      isOpen: false,
      GlobalConfig,
      peopleName: [],
      labelPosition: 'right',
      placeholder: '请参照以下格式输入（每行一个手机号）：\n13900006666\n13699998888,张三\n15233334444，李四\n15911112222',
      textareaContent: '',
      formLabelAlign: {
        taskName: '',
        endTime: '',
        count: '',
        price: '',
        detail: '',
        requirement: '',
        qulityStandard: '',
        checkoutStandard: '',
        settleMethod: 0,
        settleMode: 1,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        },
        executionRequirement: '',
        qualityControlStandard: ''
      },
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        // qualityControlStandard: [{ required: true, message: '请输入质控标准', trigger: 'blur' }],
        endTime: [
          {
            type: 'string',
            required: true,
            message: '请选择截止时间',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    toOpen() {
      window.open(
        `${window.location.origin + process.env.VUE_APP_PRE_URL}/#/cost-settlement`
      )
    },
    changeSettleMethod(btnType) {
      this.btnChecked = btnType
      this.formLabelAlign.settleMethod = this.settleMethodMap[btnType]
      this.changeSettlementType(1)
    },
    back() {
      this.$emit('comeback')
    },
    // 分配任务
    distributeTask() {
       if(!this.isOpen&&this.formLabelAlign.settleMethod==0) {
        this.$message({
          message: '尚未开通费用结算，无法设定线上结算',
          type: 'warning'
        });
        return
      }   
      if (!this.formLabelAlign.taskName || !this.formLabelAlign.endTime) {
        this.$message.error('请将必填项填写完整！')
        return
      }
      let postData = {}
      if (this.formLabelAlign.settleMode === 3) {
        const cloneLadderSettlement = [...this.formLabelAlign.settleRule.tiers]
        cloneLadderSettlement.forEach((it, i, arr) => {
          if (i > 0) {
            it.quantityLowerBound = arr[i - 1].quantityUpperBound * 1
          }
        })
        postData = {
          ...this.formLabelAlign,
          settleRule: {
            ...this.formLabelAlign.settleRule,
            tiers: cloneLadderSettlement
          }
        }
        // postData.ladderSettlement =cloneLadderSettlement;
        this.formLabelAlign = { ...postData }
      }

      let params = {
        execution: {
          surveyId: GlobalConfig.getSurveyId(),
          executionName: this.formLabelAlign.taskName,
          // executionQuantity: this.formLabelAlign.count,
          executionSingleAmount: this.formLabelAlign.price,
          executionValidateTo: this.formLabelAlign.endTime,
          executionDescription: this.formLabelAlign.detail || '',
          settleMethod: this.formLabelAlign.settleMethod || 0,
          settleMode: this.formLabelAlign.settleMode || '',
          settleRule: this.formLabelAlign.settleRule,
          executionRequirement:this.formLabelAlign.executionRequirement,
          qualityControlStandard:this.formLabelAlign.qualityControlStandard,

          userList: []
        }
      }
      // let userList = [];
      for (let val of this.data.values()) {
        params.execution.userList.push({
          userId: val.investigatorId,
          userName: val.executorName,
          phone: val.executorPhone,
          justForCode: false
        })
      }

      let tempContent = this.textareaContent.split('\n').filter(item => item.trim() !== '')
      let tempRes = []
      let phoneList = []
      tempContent.forEach(item => {
        if (item.includes(',')) {
          tempRes.push(item.split(',').map(i => i.trim()))
        } else if (item.includes('，')) {
          tempRes.push(item.split('，').map(i => i.trim()))
        } else {
          tempRes.push([item, ''])
        }
      })

      let phoneArr = []
      for (let [phone, name] of tempRes) {
        // 校验手机号和座机
        if (!(isLandline(phone) || isMobile(phone))) {
          this.$message.error('请输入正确的手机号！')
          return
        }
        phoneList.push({
          phoneNumber: phone,
          sampleName: name
        })
        phoneArr.push(phone)
      }
      params.phoneList = phoneList

      // 开始查重 去重
      // 1.查输入框重复
      let repeatPhone = new Set()
      let phone = new Set()
      let content = []
      phoneArr.forEach(item => {
        if (phoneArr.indexOf(item) !== phoneArr.lastIndexOf(item)) {
          repeatPhone.add(item)
        }
        phone.add(item)
      })

      // 下面 if 处理输入框重复的提示和自动去重操作
      if (repeatPhone.size) {
        let tem = Array.from(repeatPhone)

        // 去除输入框中的重复
        let handlerData = this.textareaContent.split('\n')
        let map = new Map()
        Array.from(phone).forEach(item => {
          let res = []
          handlerData.forEach(i => {
            if (i.indexOf(item) !== -1) {
              res.push(i)
            }
          })
          map.set(item, res)
        })
        for (let val of map) {
          content.push(val[1][0])
        }
        this.textareaContent = content.join('\n')

        // 进行提示
        this.$alert(
          `
          ${tem.slice(0, 3).join('、')}等共计${
            tem.length
          }个号码，<span style="color:#D8001B">在输入框中重复，已为您自动去重</span>，请重新提交。`,
          '重复样本号码提醒',
          {
            confirmButtonText: '确定', // 右边按钮
            cancelButtonText: '查看重复', // 左边按钮
            customClass: 'is-phone-repeat',
            type: 'warning',
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: true,
            showClose: false
          }
        ).then(
          confirm => {
            // 点击【确定】的操作 无操作
          },
          cancel => {
            // 【查看重复】按钮操作
            let data = [['重复号码']].concat(tem.map(item => [item]))
            XlsxUtil.downloadXlsx([data], { filename: '重复号码清单' })
          }
        )
      } else {
        // 这个时候输入框中没有重复了 进行第二步
        // 2.查其他任务重复
        checkPhoneList({
          surveyId: GlobalConfig.getSurveyId(),
          phoneList: phoneArr
        }).then(res => {
          // 和其他任务有重复
          if (res.data.data !== null) {
            this.$alert(
              `
              ${res.data.data
                .slice(0, 3)
                .join('、')}，<span style="color:#D8001B">以上号码已经在本问卷其他任务中存在</span>，你要删除这些号码吗？`,
              '重复样本号码提醒',
              {
                confirmButtonText: '删除',
                cancelButtonText: '重复添加',
                customClass: 'is-phone-repeat',
                type: 'warning',
                dangerouslyUseHTMLString: true,
                center: true,
                showCancelButton: true,
                showClose: false
              }
            ).then(
              confirm => {
                // 点击【删除】
                // 去重问卷其他任务重复号码
                res.data.data.forEach(item => {
                  this.textareaContent = this.textareaContent.replaceAll(item, '')
                })
                this.textareaContent = this.textareaContent
                  .split('\n')
                  .filter(i => i !== '' && ![',', '，'].includes(i.charAt(0)))
                  .join('\n')
              },
              cancel => {
                // 点击【重复添加】
                params.execution.executionQuantity = this.newCount
                // 调用接口创建任务
                creatPhoneTask(params)
                  .then(res => {
                    this.$message.success('添加任务成功！')
                    this.$emit('comeback')
                  })
                  .catch(e => {
                    this.$message.error(e.message)
                  })
              }
            )
          } else {
            // 和其他任务没有重复
            params.execution.executionQuantity = this.newCount
            // 调用接口创建任务
            creatPhoneTask(params)
              .then(res => {
                this.$message.success('添加任务成功！')
                this.$emit('comeback')
              })
              .catch(e => {
                this.$message.error(e.message)
              })
          }
        })
      }
    },
    getMore() {
      this.$refs.onlinePayServiceVisible.openDialog()
    },
    // 监听input-number值的变化
    currentInputNumber(val, item, currentIndex) {
      const baseSettleRule = JSON.parse(JSON.stringify(this.formLabelAlign.settleRule))
      baseSettleRule.tiers.forEach((it, i, arr) => {
        if (i > currentIndex) {
          it.quantityUpperBound = arr[i - 1].quantityUpperBound + 1
        }
      })
      this.formLabelAlign.settleRule = {
        ...this.formLabelAlign.settleRule,
        tiers: baseSettleRule.tiers
      }
    },
    // 切换结算方式
    changeSettlementType(val) {
      this.$refs['taskRuleForm'].clearValidate()
      this.formLabelAlign = {
        ...this.formLabelAlign,
        settleMode: val,
        settleRule: {
          unitPriceYuan: undefined, //单价 多少元/天  多少元/份
          expectedQuantity: undefined, // 数量 多少份 | 多少天
          tiers: [
            {
              quantityLowerBound: 0,
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            }
          ]
        }
      }
    },
    handleSettlement(type, index) {
      console.log(type)
      if (type === 'add') {
        const validateArr = []
        this.formLabelAlign.settleRule.tiers.forEach((it, i) => {
          validateArr.push(`settleRule.tiers[${i}].quantityUpperBound`)
          validateArr.push(`settleRule.tiers[${i}].unitPriceYuan`)
        })
        let validFlag = false
        validateArr.forEach(item => {
          this.$refs['taskRuleForm'].validateField(
            validateArr,
            valid => (validFlag = valid ? false : true) // 定义是否通过表单验证
          )
        })
        console.log('validateArr:', validateArr)
        if (validFlag) {
          if (this.formLabelAlign.settleRule.tiers.length < 5) {
            const lastTiers = this.formLabelAlign.settleRule.tiers[this.formLabelAlign.settleRule.tiers.length - 1]
            const lastObj = { quantityUpperBound: lastTiers.quantityUpperBound, unitPriceYuan: lastTiers.unitPriceYuan }

            const flagDouble = Object.values(lastObj).includes(undefined)
            if (flagDouble) {
              this.$message.error('请完善表单项')
              return
            }

            const cloneLadderSettlement = this.formLabelAlign.settleRule.tiers
            cloneLadderSettlement.push({
              quantityLowerBound: '',
              quantityUpperBound: undefined,
              unitPriceYuan: undefined
            })
            this.formLabelAlign.settleRule.tiers = cloneLadderSettlement
          } else {
            this.$message.error('最多只能添加5条数据')
          }
        } else {
          this.$message.error('请完善表单项')
        }
      } else if (type === 'remove') {
        const cloneLadderSettlement = this.formLabelAlign.settleRule.tiers

        this.formLabelAlign.settleRule.tiers = cloneLadderSettlement.filter((it, i) => index !== i)
      }
    }
  },
  computed: {
    aboutPrice() {
      let result = ((this.formLabelAlign.count * 100 * this.formLabelAlign.price) / 100 || 0).toFixed(2)
      if (Number.isNaN(result)) return 0
      return result
    },
    newCount() {
      return this.textareaContent === ''
        ? 0
        : this.textareaContent.indexOf('\n') == -1
        ? 1
        : this.textareaContent.split('\n').filter(item => item.trim() !== '').length
    },
    totalPriceYuan() {
      if (this.formLabelAlign.settleRule.expectedQuantity && this.formLabelAlign.settleRule.unitPriceYuan) {
        return (this.formLabelAlign.settleRule.expectedQuantity * this.formLabelAlign.settleRule.unitPriceYuan).toFixed(2)
      } else {
        return 0
      }
    },
    totalSaleYuan() {
      if (this.formLabelAlign.settleRule.expectedQuantity && this.formLabelAlign.settleRule.unitPriceYuan) {
        return (
          (1 + this.accRate * 1) *
          (this.formLabelAlign.settleRule.expectedQuantity * this.formLabelAlign.settleRule.unitPriceYuan)
        ).toFixed(2)
      } else {
        return 0
      }
    },
    accountingRateVal() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '6.5%' : `${accountingRate}%`
    },
    accRate() {
      const { accountingRate = 0 } = this.$store.getters || {};
      return accountingRate === null || accountingRate === 0 ? '0.065' : (accountingRate / 100).toFixed(3)
    }
  },
  created() {
    this.isOpen = this.$store.getters.settlementType !== 1
    this.formLabelAlign.taskName = this.title

    for (let val of this.data.values()) {
      this.peopleName.push(val.executorName)
    }
  },
  beforeDestroy() {
    this.formLabelAlign.taskName = ''
  }
}
</script>

<style lang="scss" scoped>
.assign-telephone-task {
  height: 100%;
  display: flex;
  flex-direction: column;
  .top-tips {
    width: 50%;
    background-color: #e6f7ff;
    border: 1px solid #a6ddff;
    padding: 3px;
    margin: 0 auto;
    .el-icon-warning {
      color: #1890ff;
    }
  }
  .content {  
    flex:1;
    .phone-list {
      padding-top: 10px;
      width: 30%;
      .text-red {
        color: #d9001b;
      }
    }
    .form-content {
      width: 65%;
    }
  }
  .self-end{
    padding: 16px 24px;
    width: 100%;
    text-align: right;
    box-sizing: border-box;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .settlement-tips{
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      span{
        color:#000;
        font-size: 22px;
        font-family: PingFangSC;
        font-weight: 500;
        margin: 0 5px;
      }
    }
    .el-button{
      width:88px
    }
  }
}
.btn-box {
  @apply flex justify-center;
  padding: 10px;
  min-height: 118px;
  width: 196px;
  border-radius: 2px;
  cursor: pointer;
  line-height: 16px;
  position: relative;
  .position-checkbox{
    position: absolute;
    right: 0;
    top: -2px;
  }
  &.btn1 {
    border: 1px solid #cccccc;
  }
  &.btn2 {
    border: 1px solid #cccccc;
    margin-left: 26px;
  }
  &.btn1.btn-checked,
  &.btn2.btn-checked {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
  }
  .tujian {
    border: 1px solid #FAAD14;
    border-radius: 8px;
    width: 34px;
    height: 16px;
    font-weight: 500;
    font-size: 12px;
  }
}
// .btn-checked div {
//   div {
//     color: #2775e8 !important;
//   }
//   i {
//     color: #2775e8 !important;
//   }
// }
.btn-box:hover {
  &.btn1,
  &.btn2 {
    background: rgba(39,117,232,0.10);
    border: 1px solid var(--theme-color) !important;
    // div {
    //   div {
    //     color: #2775e8 !important;
    //   }
    //   i {
    //     color: #2775e8 !important;
    //   }
    // }
  }
}
</style>

<style lang="scss">
.el-message-box.is-phone-repeat {
  width: 330px;
  .el-message-box__title {
    justify-content: flex-start;
  }
  .el-message-box__content {
    text-align: left;
    margin-left: 19px;
  }
  .el-message-box__btns {
    text-align: right;
  }
}
.justify-around {
  .settlementType-style .flex-box .pos-abs-box {
    position: absolute;
    display: flex;
    justify-content: flex-end;
    width: 128px;
    padding-right: 12px;
    i {
      content: '*';
      color: #e34152;
      margin-right: 4px;
    }
  }
  .settlementType-style .flex-settlement .el-form-item {
    margin-bottom: 0 !important;
  }
}
</style>
